export default __webpack_public_path__ + "static/char-thumb-50-2c28c7aad5be76ee0324833191a2c603.png";